import { render, staticRenderFns } from "./createDocument.vue?vue&type=template&id=61de2680&"
import script from "./createDocument.vue?vue&type=script&lang=js&"
export * from "./createDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports